module.exports = __webpack_public_path__ + "static/img/ws-img-signup-desktop.74b4ba0.jpg";